
import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardBody, Table, Pagination, PaginationItem, PaginationLink } from 'reactstrap'; // Added imports for Card and CardBody
import { Link } from 'react-router-dom'; // Added import for Link
import ExpenseCategoryForm from './ExpenseCategoryForm';
import CenterModal from 'components/Common/CenterModal';
import { useQuery } from "react-query";
import { getExpenseCategories, getExpenses } from "helpers/fakebackend_helper";
import ExpenseForm from './ExpenseForm';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { IMAGE_BASE_URL } from 'constants/imageUrl';


const ExpenseList = React.memo(function ExpenseList() {


  const [expenseModalOpen, setExpenseModalOpen] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const { data, isLoading, refetch } = useQuery(['expense_list', currentPage], () => getExpenses(currentPage), {
    // staleTime: 60000,
    refetchOnWindowFocus: false,
    // refetchOnMount: false, 
  });


  const toggleExpenseModal = (edit = false, id = null) => {
    if (!edit) {
      setSelectedAsset(null);
    }
    setExpenseModalOpen(!expenseModalOpen);
    if (edit) {
      setSelectedAsset(data?.expenses?.data?.find(expense => expense.id === id));
    }
  };

  const closeExpenseModal = () => {
    setExpenseModalOpen(false);
    setSelectedAsset({});
    refetch();
  };



  return (
    <Card>

      <CardBody>
        <div className="d-flex justify-content-between">
          <h4 className="card-title mb-4">Expense List</h4>
          {/* <Link to="#" className="no-underline hover:underline" onClick={toggleExpenseModal}>Add Expense</Link> */}

        </div>

        <div className="table-responsive">
        <SimpleBar style={{ maxHeight: 500 }}>

          <Table className="table table-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Category</th>
                <th scope="col">Amount </th>
                <th scope="col">Status</th>
                <th scope="col">Amount Split</th>
                <th scope="col">Created By</th>
                <th scope="col">Receipts</th>
                <th scope="col" colSpan="2">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </td>
                </tr>
              ) : 
              (
                Array.isArray(data?.expenses?.data) ? data.expenses.data.map((expense) => (
                  <tr key={expense.id}>
                    <td>{expense.name}</td>
                    <td>{expense?.category?.name}</td>
                    <td>€{expense.amount}</td>
                    <td>{expense.status}</td>

                    <td>
                      {expense?.split1_user?.name && expense?.split1_percentage ? 
                        `${expense.split1_user.name} (${expense.split1_percentage}%)` : '-'}
                      <br />
                      {expense?.split2_user?.name && expense?.split2_percentage ? 
                        `${expense.split2_user.name} (${expense.split2_percentage}%)` : '-'}
                    </td>
                    <td>{expense?.created_by?.name}</td>
                    <td>
                      {Array.isArray(expense.receipts) && expense.receipts.length > 0 ? (
                        expense.receipts.map((receipt, index) => (
                          <React.Fragment key={index}>
                            <a href={`${IMAGE_BASE_URL}/${receipt.receipt_url}`} target="_blank" rel="noreferrer">
                              {`Receipt${index + 1}`}
                            </a>
                            <br /> {/* Add line break */}
                          </React.Fragment>
                        ))
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>
                      <Link to="#" onClick={() => toggleExpenseModal(true, expense.id)}>
                        <i className="bx bx-edit font-size-18 text-success me-3" id={`edit-${expense.id}`} />
                      </Link>
                      <Link to="#">
                        <i className="bx bx-trash font-size-18 text-danger" id={`delete-${expense.id}`} />
                      </Link>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No expenses found
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </Table>
          </SimpleBar >
        </div>
        
        {/* Pagination */}
        {data?.expenses && (
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>
              Showing {data.expenses.from} to {data.expenses.to} of {data.expenses.total} entries
            </div>
            <Pagination>
              {/* Previous button */}
              <PaginationItem disabled={!data.expenses.prev_page_url}>
                <PaginationLink 
                  previous 
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={!data.expenses.prev_page_url}
                >
                  Previous
                </PaginationLink>
              </PaginationItem>
              
              {/* Page numbers */}
              {data.expenses.links && data.expenses.links.map((link, index) => {
                if (link.url && !link.label.includes('Previous') && !link.label.includes('Next')) {
                  const pageNumber = parseInt(link.label);
                  return (
                    <PaginationItem key={index} active={link.active}>
                      <PaginationLink onClick={() => setCurrentPage(pageNumber)}>
                        {link.label}
                      </PaginationLink>
                    </PaginationItem>
                  );
                }
                return null;
              })}
              
              {/* Next button */}
              <PaginationItem disabled={!data.expenses.next_page_url}>
                <PaginationLink 
                  next 
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={!data.expenses.next_page_url}
                >
                  Next
                </PaginationLink>
              </PaginationItem>
            </Pagination>
          </div>
        )}
      </CardBody>
      <CenterModal isOpen={expenseModalOpen}
        toggle={toggleExpenseModal}
        title="Expense">

        <ExpenseForm
          isEditing={selectedAsset != null}
          initialValues={selectedAsset}
          closeModal={closeExpenseModal}
        />
      </CenterModal>
    </Card>
  )
})

export default ExpenseList;

